import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LeftNavComponent } from '@shared/components/left-nav/left-nav.component';

@Component({
    selector: 'app-interior-layout',
    templateUrl: './interior-layout.component.html',
    styleUrls: ['./interior-layout.component.scss'],
    imports: [RouterOutlet, LeftNavComponent],
    standalone: true,
})
export class InteriorLayoutComponent {
    constructor() {}
}
